export const formatDateTime = (date: Date | null) => (date ? date.toLocaleString() : "—");

export const formatDuration = (ms: number | null) => {
  if (ms === null || ms < 0) return "—";
  const seconds = Math.round(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

export const runDurationMs = (
  run: { startedAt: Date | null; finishedAt: Date | null; createdAt: Date },
  now = Date.now()
) => {
  const start = run.startedAt ?? run.createdAt;
  if (run.finishedAt) return run.finishedAt.getTime() - start.getTime();
  return now - start.getTime();
};

export const formatCost = (usd: number | null) => (usd === null ? "—" : `$${usd.toFixed(usd < 1 ? 3 : 2)}`);

export const formatBytes = (bytes: number | null) => {
  if (bytes === null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatClock = (iso: string | null) => (iso ? new Date(iso).toLocaleTimeString() : "");

export const formatDelta = (fromIso: string | null, toIso: string | null) => {
  if (!fromIso || !toIso) return "";
  const ms = new Date(toIso).getTime() - new Date(fromIso).getTime();
  if (ms < 1000) return `+${ms}ms`;
  return `+${formatDuration(ms)}`;
};
